import React, { Component } from 'react';

//componentes
import CxC from './cxc'

class Index extends Component {

    render(){
        return(
            <div>
                <CxC />
            </div>
        );
    }

}
export default Index;